import { autoCapitalize } from '@/utils/autoCapitalize'

class ClinicListMapper {
  toDomain(persistenceClinicData) {
    return {
      id: persistenceClinicData?.id,
      name: autoCapitalize(persistenceClinicData?.nome),
    }
  }
}

export default new ClinicListMapper()
